import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, Routes } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';

import 'hammerjs';
import { NgbDateParserFormatter, NgbDatepickerI18n, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { ToastrModule } from 'ngx-toastr'; // For auth after login toast

import { CoreModule } from '@core/core.module';
import { CoreCommonModule } from '@core/common.module';
import { CoreSidebarModule, CoreThemeCustomizerModule } from '@core/components';

import { coreConfig } from 'app/app-config';

import { AppComponent } from 'app/app.component';
import { LayoutModule } from 'app/layout/layout.module';

import { JwtModule } from "@auth0/angular-jwt";
import { AuthLoginV2Component } from './main/pages/authentication/auth-login-v2/auth-login-v2.component';

import { ColumnChangesService, DimensionsHelper, ScrollbarHelper } from '@swimlane/ngx-datatable';

import { AuthRegisterV1Component } from './main/pages/authentication/auth-register-v1/auth-register-v1.component';
import { PagesModule } from './main/pages/pages.module';
import { AdminModule } from './main/admin/admin.module';
import { HttpErrorHandlerInterceptorService } from './services/HttpErrorHandlerInterceptorService';
import { HomeComponent } from './main/pages/home/home.component';
import { DialogsModule } from './dialogs/dialogs.module';
import { CustomDatepickerI18n, I18n } from './main/admin/deneme/date-picket-i18n/date-picket-i18n';
import { AuthService } from './services/auth.service';
import { registerLocaleData } from '@angular/common';
import localeTr from '@angular/common/locales/tr';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from 'environments/environment';

registerLocaleData(localeTr);

const accessToken = localStorage.getItem("accessToken");

export function initAuth(auth: AuthService) {
  return () => auth.identityCheck();
}

const appRoutes: Routes = [
  {
    path: 'pages',
    loadChildren: () => import('./main/pages/pages.module').then(p => p.PagesModule)
  },
  {
    path: 'admin',
    loadChildren: () => import('./main/admin/admin.module').then(p => p.AdminModule),
  },
  {
    path: '',
    redirectTo: accessToken ? 'admin/dashboard' : 'pages/authentication/login-v2',
    pathMatch: 'full'
  },
  /*
  {
    path:'',
    component:HomeComponent,
    loadChildren: ()=>import('./main/pages/home/home.module').then(p=>p.HomeModule),
  },*/
  {
    path: '**',
    redirectTo: '/pages/miscellaneous/error' //Error 404 - Page not found
  },
];

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // registrationStrategy: 'registerWhenStable:30000' // opsiyonel
    }),

    JwtModule.forRoot({
      config: {
        tokenGetter: () => localStorage.getItem("accessToken"),
        allowedDomains: ["api.rezonans.ustacrm.com"],
      }
    }),
    RouterModule.forRoot(appRoutes, {
      scrollPositionRestoration: 'enabled'
    }),
    TranslateModule.forRoot(),

    //NgBootstrap
    NgbModule,
    ToastrModule.forRoot(),

    // Core modules
    CoreModule.forRoot(coreConfig),
    CoreCommonModule,
    CoreSidebarModule,
    CoreThemeCustomizerModule,
    //AdminModule,
    //PagesModule,
    // App modules
    DialogsModule,
    LayoutModule,
  ], 
  providers: [  
    ScrollbarHelper,
    DimensionsHelper,
    ColumnChangesService,
    I18n,
    {
      provide: "baseurl", useValue: "https://api.rezonans.ustacrm.com/api", multi: true
    },
    {
      provide: "backendUrl", useValue: "https://api.rezonans.ustacrm.com/", multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initAuth,
      deps: [AuthService],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS, useClass: HttpErrorHandlerInterceptorService, multi: true
    },
    { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n },
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    }
    // { provide: HTTP_INTERCEPTORS, useClass: UrlInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }